module.exports = __webpack_public_path__ + "static/media/OJKShort.87ee3975.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/OJKShort.png
// module id = 372
// module chunks = 11